(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewBaseAssignmentReport.controller:CrewBaseAssignmentReportCtrl
   *
   * @description
   *
   */
    angular
        .module('crewBaseAssignmentReport')
        .controller('CrewBaseAssignmentReportCtrl', CrewBaseAssignmentReportCtrl)
        .directive('focusOn',function($timeout) {
            return {
                restrict : 'A',
                link : function(vm,$element,$attr) {
                    vm.$watch($attr.focusOn,function(_focusVal) {
                        $timeout(function() {
                            _focusVal ? $element[0].focus() : $element[0].blur();
                        });
                    });
                }
            }
        });

    function CrewBaseAssignmentReportCtrl(CommonMasterData,$sce, CommonLogicService) {
        var vm = this;
        vm.ctrlName = 'CrewBaseAssignmentReportCtrl';

        vm.model = {
            searchPanelToggle : true,
            searchCriteria : {
                fromDate : null,
                toDate : null,
                crewType : null,
                crewBase : null
            },
            masterList : {
                crewTypeList : [],
                crewBaseList :[],
                fromDateAfterToDate : false,
                fromDateFormatInvalid : false,
                toDateFormatInvalid : false
            },
            initialSearchDone : false,
            reportDataURL : null
        };

        // toggle search
        vm.clickOnSearch = function() {
            vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
            vm.model.initialSearchDone = false;
        };

        // submit search
        vm.submitSearch = function(params) {
            searchCrewBaseAssignmentReport(params);
        };

        // on change search field
        vm.changeSearchField = function(searchParams, flag) {
            if(flag === 'fromDate' || flag === 'toDate'){
                setDateValidationFlags();
                var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
                if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
                    searchParams.toDate = tempFromDate;
                }
                if(!!searchParams.fromDate && !!searchParams.toDate
                    && !vm.model.masterList.fromDateFormatInvalid  && !vm.model.masterList.toDateFormatInvalid){
                    if (istoDateBeforeFromDate()) {
                        vm.model.masterList.fromDateAfterToDate = true;
                    }else{
                        vm.model.masterList.fromDateAfterToDate = false;
                    }
                }
            }
        };

        function setDateValidationFlags(){
            //if from date invalid
            if(isDateFormatInvalid(vm.model.searchCriteria.fromDate)){
                vm.model.masterList.fromDateFormatInvalid = true;
                vm.model.masterList.fromDateAfterToDate = false;
            }else{
                vm.model.masterList.fromDateFormatInvalid = false;
            }

            //if to date invalid
            if(isDateFormatInvalid(vm.model.searchCriteria.toDate)){
                vm.model.masterList.toDateFormatInvalid = true;
                vm.model.masterList.fromDateAfterToDate = false;
            }else{
                vm.model.masterList.toDateFormatInvalid = false;
            }
        }

        function isDateFormatInvalid(date){
            if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
                return true;
            }
            return false;
        }

        // check from date and to date
        function istoDateBeforeFromDate() {
            return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY").isBefore(moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY"));
        }

        function searchCrewBaseAssignmentReport(param) {
            vm.model.initialSearchDone = true;
            if (isValidSearchParams(param)) {
                vm.model.searchCriteria = param;
                vm.model.searchPanelToggle = false;

                var rptDesign = "crew_base_assignment_report.rptdesign";

                var dataMap = getSearchParamMap(param);
                var data = {
                    periodStartDateTime : dataMap["fromDate"],
                    periodEndDateTime : dataMap["toDate"],
                    crewTypeCode : dataMap["crewType"],
                    baseAirport : dataMap["crewBase"]
                };

                var url = CommonLogicService.getReportUrl(rptDesign,data);
                vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
            }
        }

        //set search param map
        function getSearchParamMap(param){
            var searchParamMap = {};
            searchParamMap["fromDate"] = param.fromDate;
            searchParamMap["toDate"] = param.toDate;
            if(param.crewType != null) {
                searchParamMap["crewType"] = param.crewType.crewTypeCode;
            } else {
                searchParamMap["crewType"] = "";
            }
            searchParamMap["crewBase"] = (!!param.crewBase && !!param.crewBase.airPortCode) ? param.crewBase.airPortCode:'';
            return searchParamMap;
        }

        //validate search Params
        function isValidSearchParams(params) {
            setDateValidationFlags();
            // if date invalid
            if(vm.model.masterList.fromDateFormatInvalid  || vm.model.masterList.toDateFormatInvalid){
                vm.model.masterList.fromDateAfterToDate = false;
                return false;
            }else if (istoDateBeforeFromDate()) {
                vm.model.masterList.fromDateAfterToDate = true;
                return false;
            }
            vm.model.masterList.fromDateAfterToDate = false;
            return true;
        }

        //init loading
        (
            function() {
                //get crew types
                CommonMasterData.getCrewTypeList(function(crewTypeList) {
                    vm.model.masterList.crewTypeList = crewTypeList;
                }, function() {
                    console.log('Crew Type list retrieval error');
                });

                // base list
                CommonMasterData.getCrewBaseList(function(crewBases) {
                    vm.model.masterList.crewBaseList = crewBases;
                }, function() {
                    console.log('Crew Base List retrieval error');
                });
            }
        )();
    }
}());
